import React from 'react';
import { withHydrate } from '@ecommerce/nest-ssr/common';

import StaticLayoutDesktop from 'layouts/static/static.desktop';
import AboutUsBase from './about-us.base';

import './about-us.desktop.scss';

const AboutUsDesktop: React.FC<{ title: string; }> = ({ title }) => (
    <StaticLayoutDesktop title={title}>
        <AboutUsBase />
    </StaticLayoutDesktop>
);

export default withHydrate(AboutUsDesktop, { root: '#root' }, 'views/pages/static/about-us/about-us.desktop');
